export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAIL = 'UPDATE_USER_FAIL';

export const ADD_USER_TO_TEAM = 'ADD_USER_TO_TEAM';
export const ADD_USER_TO_TEAM_SUCCESS = 'ADD_USER_TO_TEAM_SUCCESS';
export const ADD_USER_TO_TEAM_FAIL = 'ADD_USER_TO_TEAM_FAIL';

export const REMOVE_USER_FROM_TEAM = 'REMOVE_USER_FROM_TEAM';
export const REMOVE_USER_FROM_TEAM_SUCCESS = 'REMOVE_USER_FROM_TEAM_SUCCESS';
export const REMOVE_USER_FROM_TEAM_FAIL = 'REMOVE_USER_FROM_TEAM_FAIL';
